import {Pipe, PipeTransform} from '@angular/core';
import { getUTC } from '../../helpers/helpers';

@Pipe({
  name: 'formattedDate',
})
export class FormattedDatePipe implements PipeTransform {

  transform(date: any, format?: string, utc?: boolean): string {
    if (!date) {
      return '';
    }

    if (typeof date === 'string') {
      date = new Date(date);
    }

    if (utc) {
      date = getUTC(date);
    }

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'January', 'February', 'March', 'April',
      'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December',
    ];
    const isToday = (d: Date) => {
      const today = new Date();

      return d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();
    };

    const isYesterday = (d: Date) => {
      const today = new Date();
      const yesterday = new Date(today);

      yesterday.setDate(yesterday.getDate() - 1);

      today.toDateString();
      yesterday.toDateString();

      return d.getDate() === yesterday.getDate() &&
        d.getMonth() === yesterday.getMonth() &&
        d.getFullYear() === yesterday.getFullYear();
    };

    const isThisYear = (d: Date) => {
      const currentYear = new Date().getUTCFullYear();
      return currentYear === d.getFullYear();
    };

    const getAdaptiveDayOfMonth = (d: Date, mod: string): string => {
      const year = d.getFullYear();
      const month = months[d.getMonth()].slice(0, 3);
      const day = d.getDate();
      const hours = d.getHours() > 9 ? d.getHours() : '0' + d.getHours();
      const minutes = d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes();
      const diffYears = new Date().getFullYear() - year;

      let prefixDate;

      if (isToday(d)) {
        prefixDate = 'Today';
      } else if (isYesterday(d)) {
        prefixDate = 'Yesterday';
      } else {
        prefixDate = `${month} ${day}`;
      }

      switch (mod) {
        case 'MM d a, HH:mm':
          return prefixDate + `, ${hours}:${minutes}`;
        case 'MM d a, yyyy':
          return prefixDate + (isToday(d) || isYesterday(d) ? '' : (', ' + year));
        case 'MMM d a, HH:mm yyyy':
          return prefixDate + `, ` + (isThisYear(d) ? '' : `${year}, `) + `${hours}:${minutes}`;
        case 'MMM DD, YYYY, HH':
          return `${month} ${day}, ${d.getFullYear()}, ${hours}:${minutes}`;
        case 'custom':
          return prefixDate + (isThisYear(d) ? '' : `, ${year} `);
      }

      return prefixDate + `${hours}:${minutes}`;
    };

    let formattedDate = '';

    switch (format) {
      case 'MM/dd/yyyy':
        const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        const year = date.getFullYear();
        formattedDate = `${month}/${day}/${year}`;
        break;
      case 'MMM dd, yyyy':
        formattedDate = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
        break;
      case 'MM d a, HH:mm':
        formattedDate = getAdaptiveDayOfMonth(date, format);
        break;
      case 'MM d, yyyy':
        formattedDate = getAdaptiveDayOfMonth(date, format);
        break;
      case 'MM d a, yyyy':
        formattedDate = getAdaptiveDayOfMonth(date, format);
        break;
      case 'MMM d a, HH:mm yyyy':
        formattedDate = getAdaptiveDayOfMonth(date, format);
        break;
      case 'MMM DD, YYYY, HH':
          formattedDate = getAdaptiveDayOfMonth(date, format);
          break;
      case 'custom':
        formattedDate = getAdaptiveDayOfMonth(date, format);
        break;
      default:
        formattedDate = `${days[date.getDay()]}, ${months[date.getMonth()]} ${date.getDate()}`;
        break;
    }

    return formattedDate;
  }

}
